var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../lib/utils';
var Layout = function (_a) {
    var children = _a.children, className = _a.className;
    return (_jsx("div", __assign({ className: cn("min-h-screen bg-background transition-colors duration-300 overflow-x-hidden w-full max-w-[100vw]", className) }, { children: children })));
};
export default Layout;
